import { useState, type FormEvent } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import { AuthShell } from '../../components/admin/AuthShell';
import { Button, Input, useToast } from '../../components/ui';
import { api, errorMessage } from '../../lib/api';

export function AdminResetPage() {
  const [sp] = useSearchParams();
  const token = sp.get('token') ?? '';
  const [password, setPassword] = useState('');
  const [done, setDone] = useState(false);
  const toast = useToast();

  async function onSubmit(e: FormEvent): Promise<void> {
    e.preventDefault();
    try {
      await api.post('/admin/auth/reset', { token, password });
      setDone(true);
    } catch (err) {
      toast.push(errorMessage(err), 'error');
    }
  }

  return (
    <AuthShell title="Choose a new password">
      {done ? (
        <p>
          Password updated.{' '}
          <Link to="/admin/login" className="text-navy-900 underline">
            Sign in
          </Link>
        </p>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4">
          <Input type="password" label="New password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          <Button type="submit" className="w-full">
            Update password
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
